<div class="live-edit-container">
  <router-outlet></router-outlet>
</div>
<vnext-live-edit-state-selector></vnext-live-edit-state-selector>
